module.exports = __webpack_public_path__ + "media/images/overdue-d28350b9ef0afc7b1d26a32f2724e80f.png";